<ym-topbar class="ym-display-block ym-border-b-1 ym-border-b-solid ym-border-gray-a-16"
    [showBackNavigation]="showBackNavigation">
    <ng-container left>
        <ng-content select="[left]"></ng-content>
    </ng-container>
    <ng-container center>
        <ng-content select="[center]"></ng-content>
    </ng-container>
    <ng-container right>
        <ng-content select="[right]"></ng-content>
    </ng-container>
</ym-topbar>